

export interface AppErrorOptions extends ErrorOptions {
    dontReport?: true;
}

export class AppError extends Error {
    readonly dontReport?: true;

    constructor(message: string, options?: AppErrorOptions) {
        super(message, options);
        this.name = new.target.name;

        Object.setPrototypeOf(this, new.target.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, new.target);
        }

        this.dontReport = options?.dontReport;
    }

    toJSON() {
        return {
            name: this.name,
            message: this.message,
            dontReport: this.dontReport,
            cause: this.cause instanceof Error ? this.cause.message : this.cause,
        };
    }
}


// Error class for expected circumstances when an operation cannot be completed.
// The occurrance of this error does not indicate a bug or unexpected failure.
export class ExpectedError extends AppError {
    constructor(message: string, options?: ErrorOptions) {
        super(message, { ...options, dontReport: true });
    }
}
